import React, { FC, useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Spinner } from 'react-bootstrap'
import moment from 'moment'
import NodataYet from '../../../Components/NodataYet'
import ReactDatePicker from 'react-datepicker'
import { ENV } from '../../../Utils/_helpers/EnvHelper'
import { useLazyExportUserOrderAdminListQuery, useLazyGetSalesCommissionListQuery } from '../../../../services/cellcast.v2'

import { CommissionFilter } from '../../../../services/cellcast.type'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { GetAllStaff } from '../MyProfile/Staff_Account/StaffAccountSlice/StaffAccountSlice'
import { getAllUserDetails } from '../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import { ROLES } from '../../../Utils/Constant/roles'

const CommissionPage: FC = () => {
  const dispatch = useDispatch();
  const [exportData, {isLoading: isLoadingExport}] = useLazyExportUserOrderAdminListQuery()
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const userDetail = useSelector(getAllUserDetails)
  
  const today = new Date()
  const sevenDaysAgo = new Date(today.getTime() - 120 * 24 * 60 * 60 * 1000)

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([sevenDaysAgo, new Date()])
  const [startDate, endDate] = dateRange

  const [params, setParams] = useState<CommissionFilter>({
    fromDate: moment(startDate).format('YYYY-MM-DD'),
    toDate: moment(endDate).format('YYYY-MM-DD'),
    userId: userDetail.role === ROLES.SUPER_ADMIN ? '' : userDetail?._id,
  })

  const [triggerFetch, setTriggerFetch] = useState(false)

  const [fetch, { isLoading, data, isFetching }] = useLazyGetSalesCommissionListQuery()
  const stafflist = useSelector((state: any) => state?.StaffAccount?.staffAccountList)

  useEffect(() => {
    fetch(params)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    dispatch(
      GetAllStaff({
        page: {
          page: 1,
          size: 50,
          search: '',
        },
      })
    )
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (triggerFetch && triggerFetch === true) {
      doFetch(params)
    }
    setTriggerFetch(false)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerFetch])

  const setDateParams = (dateRangeParams: [Date | null, Date | null]) => {
    let [startDate, endDate] = dateRangeParams

    if (endDate === null) {
      endDate = new Date()
    }

    setParams({
      ...params,
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
    })
    setDateRange(dateRangeParams)
    setTriggerFetch(true)
  }

  const doFetch = useCallback(
    (params) => {
      fetch(params)
        .then((res) => {
          if ('data' in res) {
          } else if ('error' in res) {
            toast.error(res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    },
    [fetch]
  )

  const handleExports = useCallback(() => {
    exportData({
      userId: params.userId,
      fromDate: params.fromDate,
      toDate: params.toDate,
    })
      .then((res) => {
        if ('data' in res) {
          window.open(`${API_DOMAIN}${res.data?.data.downloadurl}`, '_self')
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error export:', res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.fromDate, params.toDate, params.userId])


  const staffListOptions = () => {
    const defaultOptions = [{
      value: ``,
      label: `All`,
    }]

    const list = stafflist?.items ? stafflist?.items?.map((key: any) => ({
      value: `${key?._id}`,
      label: `${key?.name}`,
    })) : [];
    return [...defaultOptions, ...list];
  };

  const handleSetParams = (value: string) => {
    setParams((params) => ({
      ...params,
      userId: value,
    }));
    setTriggerFetch(true)
  };

  // TODO: use when switch to v1
  // const hasBellowVolume = !!data?.data?.bellow_target?.volume;
  // const hasWithinVolume = !!data?.data?.within_target?.volume;
  // const hasAboveVolume = !!data?.data?.above_target?.volume;

  const formatUSD = (val: any) => {
    const data: any = new Intl.NumberFormat('en-US').format(val)
    return data
  }

  return (
    <div className='mt-8'>
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>Client Sale Commission</span>
            </h3>
            <div className='d-flex justify-content-between align-items-center w-100'>
              <div className='col-md-6'>
                <div className='d-flex gap-4'>
                  {userDetail.role === 'superAdmin' ? (
                    <Select
                      onChange={(e: any) => handleSetParams(e.value)}
                      options={staffListOptions()}
                    />
                  ) : null}
                  <div className='d-flex'>
                    <ReactDatePicker
                      selectsRange={true}
                      dateFormat='MMM d, yyyy'
                      className=' border-0 form-control form-control-lg form-control-solid'
                      placeholderText='Pick data & time'
                      onChange={(update) => {
                        setDateParams(update)
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      disabled={isLoading}
                    />
                    <span
                      className='input-group-text'
                      style={{ backgroundColor: '#f5f8fa', borderRadius: 0, borderColor: '#f5f8fa' }}
                    >
                      <i className='bi bi-calendar'></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className='d-flex align-items-center gap-4'>
                <button type='button' className='btn btn-primary' onClick={() => handleExports()}>
                  {isLoadingExport ? <Spinner /> : 'Export'}
                </button>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data?.list && data?.data?.list.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='min-w-200px'>Created</th>
                        <th className='min-w-140px'>Client Name</th>
                        <th className='min-w-120px'>Type</th>
                        <th className='min-w-140px'>Coupon</th>
                        <th className='min-w-140px'>Volume</th>
                        <th className='min-w-140px'>Total amount with GST</th>
                        <th className='min-w-120px'>Total amount without GST</th>
                        <th className='min-w-150px'>Total COGS</th>
                        <th className='min-w-100px'>Rate</th>
                        <th className='min-w-100px'>Commission</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={20} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.list && data?.data?.list?.map((item, i: number) => (
                            <React.Fragment key={i}>
                              <tr className='border-dashed border-2 border-bottom'>
                                <td className='top-align'>{item?.createdAt || '--'}</td>
                                <td className='top-align'>{item?.name || '--'}</td>
                                <td className='top-align'>{item?.type || '--'}</td>
                                <td className='top-align'>{item?.coupon || '--'}</td>
                                <td className='top-align'>{formatUSD(item?.volume) || '--'}</td>
                                <td className='top-align'>${formatUSD(item?.totalAmountWithGST?.toFixed(2)) || '--'}</td>
                                <td className='top-align'>${formatUSD(item?.totalAmountWithoutGST?.toFixed(2)) || '--'}</td>
                                <td className='top-align'>${formatUSD(item?.totalAmountCOG?.toFixed(2)) || '--'}</td>
                                <td className='top-align'>{`${(item?.commissionRate).toFixed(2)}%` || '--'}</td>
                                <td className='top-align'>${formatUSD(item?.commission?.toFixed(2)) || '--'}</td>
                              </tr>
                            </React.Fragment>
                          ))}
                          {/* TODO: use when switch to v1 <tr>
                            <td className='top-align'colSpan={4}>Total bellow target</td>
                            <td className='top-align'>{hasBellowVolume ? formatUSD(data?.data?.bellow_target?.volume?.toFixed(2)) : ''}</td>
                            <td className='top-align'>{hasBellowVolume ? `$${formatUSD(data?.data?.bellow_target?.sale_gst?.toFixed(2))}` : ''}</td>
                            <td className='top-align'>{hasBellowVolume ? `$${formatUSD(data?.data?.bellow_target?.sale_without_gst?.toFixed(2))}` : ''}</td>
                            <td className='top-align'>{hasBellowVolume ? `$${formatUSD(data?.data?.bellow_target?.cog)}` : ''}</td>
                            <td className='top-align'>{hasBellowVolume ? `${(data?.data?.bellow_target?.rate * 100).toFixed(2)}%` : ''}</td>
                            <td className='top-align'>{hasBellowVolume ? `$${formatUSD(data?.data?.bellow_target?.commission?.toFixed(2))}` : ''}</td>
                          </tr>
                          <tr>
                            <td className='top-align' colSpan={4}>Total within target</td>
                            <td className='top-align'>{hasWithinVolume ? formatUSD(data?.data?.within_target?.volume?.toFixed(2)) : ''}</td>
                            <td className='top-align'>{hasWithinVolume ? `$${formatUSD(data?.data?.within_target?.sale_gst?.toFixed(2))}` : ''}</td>
                            <td className='top-align'>{hasWithinVolume ? `$${formatUSD(data?.data?.within_target?.sale_without_gst?.toFixed(2))}` : ''}</td>
                            <td className='top-align'>{hasWithinVolume ? `$${formatUSD(data?.data?.within_target?.cog)}` : ''}</td>
                            <td className='top-align'>{hasWithinVolume ? `${(data?.data?.within_target?.rate * 100).toFixed(2)}%` : ''}</td>
                            <td className='top-align'>{hasWithinVolume ? `$${formatUSD(data?.data?.within_target?.commission?.toFixed(2))}` : ''}</td>
                          </tr>
                          <tr>
                            <td className='top-align' colSpan={4}>Total above target</td>
                            <td className='top-align'>{hasAboveVolume ? formatUSD(data?.data?.above_target?.volume?.toFixed(2)) : ''}</td>
                            <td className='top-align'>{hasAboveVolume ? `$${formatUSD(data?.data?.above_target?.sale_gst?.toFixed(2))}` : ''}</td>
                            <td className='top-align'>{hasAboveVolume ? `$${formatUSD(data?.data?.above_target?.sale_without_gst?.toFixed(2))}` : ''}</td>
                            <td className='top-align'>{hasAboveVolume ? `$${formatUSD(data?.data?.above_target?.cog)}` : ''}</td>
                            <td className='top-align'>{hasAboveVolume ? `${(data?.data?.above_target?.rate * 100).toFixed(2)}%` : ''}</td>
                            <td className='top-align'>{hasAboveVolume ? `$${formatUSD(data?.data?.above_target?.commission?.toFixed(2))}` : ''}</td>
                          </tr> */}
                          <tr>
                            <td className='top-align' colSpan={4}>OVERALL TOTAL</td>
                            <td className='top-align'>{formatUSD(data?.data?.overall_total?.volume?.toFixed(2))}</td>
                            <td className='top-align'>{`$${formatUSD(data?.data?.overall_total?.sale_gst?.toFixed(2))}`}</td>
                            <td className='top-align'>{`$${formatUSD(data?.data?.overall_total?.sale_without_gst?.toFixed(2))}`}</td>
                            <td className='top-align'>{`$${formatUSD(data?.data?.overall_total?.cog?.toFixed(2))}`}</td>
                            <td className='top-align'></td>
                            <td className='top-align'>{`$${formatUSD(data?.data?.overall_total?.commission?.toFixed(2))}`}</td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <NodataYet message='No Commission (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default CommissionPage
